import * as React from "react";
import { observer } from "mobx-react";
import {
  GridList,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  FormControl,
  Snackbar,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { DevelopmentStore } from "../../DevelopmentStore";
import { DevelopmentService } from "modules/development/DevelopmentService";
import CardGrid from "modules/development/components/layouts/CardGrid";
import {
  NoResultsFound,
  NoResultsSearchFound,
} from "modules/development/components/layouts";
import CreateSelect from "common/components/CreatableSelect";
import CloseIcon from "@material-ui/icons/Close";
import i18n from "i18n";
import { StyleSheet, css } from "aphrodite";
import { ProfileService } from "modules/profile/ProfileService";
import { LoginService } from "modules/login/LoginService";
import { LoginStore } from "modules/login/LoginStore";

const styles = StyleSheet.create({
  root: {
    display: "flex",
    flex: 0,
    justifyContent: "flex-start",
    paddingTop: "25px",
    height: "calc(100vh - 128px)",
    backgroundColor: "#F4F4F4",
    overflow: "auto",
  },
  gridList: {
    margin: "0px !important",
    padding: 15,
  },
  closeIcon: {
    right: "20px",
    top: "14px",
  },
  paper: {
    width: 500,
    backgroundColor: "white",
    padding: 40,
  },
  button: {
    display: "flex",
    marginBottom: "12px",
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "520px",
    margin: "0 auto",
    marginTop: "30px",
    marginBottom: "70px",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  chips: {
    display: "flex" as any,
    flexWrap: "wrap" as any,
  },
  chip: {
    margin: "0px 5px",
  },
});

const createOption = (label: string, uid: string) => ({
  label,
  value: label,
  uid,
});

@observer
class DevelopmentGridList extends React.Component {
  state: any = {
    disabledDeleteModalActions: false,
    emails: Array(),
    inputValue: "",
    value: [],
    message: "",
    open: false,
    openShare: false,
  };

  // CHANGE IMAGE EVENTS
  handleChangeImage = async (e, props) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];

    if (file) {
      var allowedExtensions = /(\.jpg|\.gif|\.png)$/i;
      if (!allowedExtensions.exec(file.name)) {
        e.target.value = null;
        file = null;
        this.setState({
          open: true,
          message: i18n.library.message.errorImageFormat,
        });
        return;
      }

      if (file.size > 512000)
        this.setState({
          open: true,
          message: i18n.developments.exceptions.filetobig500k,
        });
      else
        await DevelopmentService.changeDevelopmentImage(
          DevelopmentStore.updateImageDevelopment,
          file
        );
    }
    this.handleFocusBack();
  };
  handleFocusBack = () => {
    DevelopmentStore.updateImageDevelopment = false;
    window.removeEventListener("focus", this.handleFocusBack);
  };
  clickedFileInput = () =>
    window.addEventListener("focus", this.handleFocusBack);

  // DELETE EVENTS
  handleClose = () => {
    DevelopmentStore.deleteDevelopment = false;
    DevelopmentStore.removAccessDevelopment = false;
    this.setState({ value: [] });
    DevelopmentStore.openShareDevelopmentDialog = false;
  };

  handleRemovAccessConfirm = async () => {
    await DevelopmentService.RemovAccessDevelopment(
      DevelopmentStore.removAccessDevelopment
    );
    DevelopmentStore.removAccessDevelopment = false;
    this.state.disabledDeleteModalActions = false;
  };

  handleConfirm = () =>
    this.setState({ disabledDeleteModalActions: true }, async () => {
      await DevelopmentService.DeleteDevelopment(
        DevelopmentStore.deleteDevelopment
      );
      DevelopmentStore.deleteDevelopment = false;
      this.state.disabledDeleteModalActions = false;
    });

  componentDidMount() {
    DevelopmentStore.developmentSelected = undefined as any;
    DevelopmentStore.loading = true;
  }

  handleChange = (value: any) => {
    this.setState({ value });
  };

  handleInputChange = (inputValue, action: any) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      this.setState({ inputValue });
    }
  };

  handleCloseSnack = () => {
    this.setState({ open: false });
  };

  handleOpenShareSnack = (msg) => {
    this.setState({ openShare: true, inputValue: "", message: msg });
  };

  handleCloseShareSnack = () => {
    this.setState({ openShare: false });
  };

  handleBlur(event) {
    if (this.state.inputValue) {
      this.handleChange({
        value: this.state.inputValue,
        label: this.state.inputValue,
      });
    }
  }

  handleKeyDown = async (event) => {
    const { inputValue, value } = this.state;
    if (!inputValue) return;

    switch (event.which) {
      case 13:
      case 32:
      case 9:
        event.preventDefault();
        event.stopPropagation();
        let emailUser = await LoginService.FetchUserByEmail(inputValue, false);
        let uid = ProfileService.getUserId();

        if (
          emailUser &&
          emailUser.uid != uid &&
          !value.find((v) => v.value === emailUser.email)
        ) {
          this.setState({
            inputValue: "",
            value: [...value, createOption(inputValue, emailUser.uid)],
          });
        }

        if (!emailUser || emailUser === null) {
          this.handleOpenShareSnack(i18n.rateLibraries.error.emailNotFound);
        } else if (emailUser.uid === uid) {
          this.handleOpenShareSnack(i18n.rateLibraries.error.emailsOwner);
        } else if (value.find((v) => v.value === emailUser.email)) {
          this.handleOpenShareSnack(i18n.rateLibraries.error.emailAlreadyAdded);
        }
    }
  };

  handleUpdateonClick = async () => {
    const { inputValue, value } = this.state;
    let emailUser = await LoginService.FetchUserByEmail(inputValue, false);
    let uid = ProfileService.getUserId();

    if (
      emailUser &&
      emailUser !== null &&
      emailUser.uid != uid &&
      !value.find((v) => v.value === emailUser.email)
    ) {
      this.setState({
        inputValue: "",
        value: [...value, createOption(inputValue, emailUser.uid)],
      });
    }

    if (!emailUser || emailUser === null) {
      this.handleOpenShareSnack(i18n.rateLibraries.error.emailNotFound);
      return false;
    } else if (emailUser.uid === uid) {
      this.handleOpenShareSnack(i18n.rateLibraries.error.emailsOwner);
      return false;
    } else if (value.find((v) => v.value === emailUser.email)) {
      this.handleOpenShareSnack(i18n.rateLibraries.error.emailAlreadyAdded);
      return false;
    }

    return true;
  };

  handleUpdate = async () => {
    let saveItens: any = this.state.value.map((id) => id.uid);
    DevelopmentStore.saveUsers(saveItens);
    this.setState({ value: [] });
    DevelopmentStore.shareUsers = [];
    DevelopmentStore.openShareDevelopmentDialog = false;
  };

  handleEnter = async () => {
    let currentUser: any = await LoginStore.getAuthenticatedUserData();
    let uid: any = await DevelopmentStore.shareUsers;
    let emailValue: any = [];
    if (this.state.value > 0) {
      return;
    }
    for (let index = 0; index < uid.length; index++) {
      if (uid[index] == undefined) return;
      if (uid[index].email == currentUser.email) {
        emailValue.splice(index, 1);
      } else {
        this.setState({
          value: [
            ...this.state.value,
            createOption(uid[index].email.toString(), uid[index].uid),
          ],
        });
      }
    }
  };

  render() {
    const { disabledDeleteModalActions } = this.state;

    return (
      <div className={css(styles.root)}>
        {DevelopmentStore.developments.length > 0 ? (
          DevelopmentStore.developmentsView.length > 0 ? (
            <GridList className={css(styles.gridList)}>
              {DevelopmentStore.developmentsView.map((dev) => (
                <CardGrid
                  key={dev.id}
                  development={dev}
                  selected={
                    DevelopmentStore.developmentSelected
                      ? DevelopmentStore.developmentSelected.id === dev.id
                      : false
                  }
                />
              ))}
            </GridList>
          ) : (
            <NoResultsSearchFound />
          )
        ) : (
          <NoResultsFound
            target={i18n.noresults.project}
            subtarget={i18n.noresults.project}
          />
        )}
        <input
          type="file"
          ref={(node) => (DevelopmentStore.buttonFileUpload = node)}
          onClick={this.clickedFileInput}
          accept=".jpg, .gif, .png, .gif"
          onChange={this.handleChangeImage.bind(this)}
          style={{ display: "none" }}
        />
        <Dialog
          open={DevelopmentStore.deleteDevelopment ? true : false}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
        >
          <DialogTitle>
            {i18n.developments.delete.title}
            <IconButton
              onClick={this.handleClose}
              className={css(styles.closeIcon)}
              style={{ position: "absolute" }}
              disabled={disabledDeleteModalActions}
            >
              <Close fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {i18n.developments.delete.content}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleClose}
              disabled={disabledDeleteModalActions}
              color="secondary"
            >
              {i18n.cancel}
            </Button>
            <Button
              onClick={this.handleConfirm}
              disabled={disabledDeleteModalActions}
              color="primary"
              autoFocus
            >
              {i18n.developments.delete.confirm}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={DevelopmentStore.openShareDevelopmentDialog}
          onClose={this.handleClose}
          onEnter={this.handleEnter}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {i18n.developments.shareDevelopment}
          </DialogTitle>
          <DialogContent style={{ width: 600 }}>
            <FormControl className={css(styles.input)}>
              <CreateSelect
                inputValue={this.state.inputValue}
                handleChange={this.handleChange}
                handleInputChange={this.handleInputChange}
                handleKeyDown={this.handleKeyDown}
                onChange={this.handleChange}
                onInputChange={this.handleInputChange.bind(this)}
                onKeyDown={this.handleKeyDown}
                value={this.state.value}
                isSearchable
                placeholder={i18n.rateLibraries.layerAdd.sharePlaceholder}
                isMulti
                onBlur={this.handleBlur.bind(this)}
                isClearable
              ></CreateSelect>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="secondary">
              {i18n.cancel}
            </Button>
            <Button
              // disabled={this.state.value == 0}
              onClick={async () => {
                if (this.state.inputValue != "") {
                  let isMessage = await this.handleUpdateonClick();
                  if (isMessage == false) return;
                }
                this.handleUpdate();
              }}
              color="primary"
            >
              {i18n.share}
            </Button>
          </DialogActions>
        </Dialog>
        {/*  */}
        <Dialog
          open={DevelopmentStore.removAccessDevelopment ? true : false}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
        >
          <DialogTitle>
            {i18n.developments.removeAccessAlert.title}
            <IconButton
              onClick={this.handleClose}
              className={css(styles.closeIcon)}
              style={{ position: "absolute" }}
              disabled={disabledDeleteModalActions}
            >
              <Close fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {i18n.developments.removeAccessAlert.content}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleClose}
              disabled={disabledDeleteModalActions}
              color="secondary"
            >
              {i18n.cancel}
            </Button>
            <Button
              onClick={this.handleRemovAccessConfirm}
              disabled={disabledDeleteModalActions}
              color="primary"
              autoFocus
            >
              {i18n.developments.removeAccessAlert.confirm}
            </Button>
          </DialogActions>
        </Dialog>
        {/*  */}
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.open}
          message={<span id="message-id">{this.state.message}</span>}
          onClose={this.handleCloseSnack}
          autoHideDuration={6000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={this.handleCloseSnack}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.openShare}
          message={<span id="message-id">{this.state.message}</span>}
          onClose={this.handleCloseShareSnack}
          autoHideDuration={4000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={this.handleCloseShareSnack}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
        {(DevelopmentStore.loading ||
          DevelopmentStore.loadingCopy ||
          DevelopmentStore.loadingWbsUpdate) && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              backgroundColor: "#fff",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              zIndex: 2,
            }}
          >
            <CircularProgress
              size={100}
              style={{ margin: "0 auto", color: "#9FB408" }}
            />
            <Typography
              style={{
                position: "absolute",
                marginLeft: "calc(50% - 65px)",
                marginTop: "170px",
              }}
            >
              {DevelopmentStore.loadingWbsUpdate
                ? i18n.developments.loadingUpdateWbs
                : i18n.developments.loading}
            </Typography>
          </div>
        )}
      </div>
    );
  }
}

export default DevelopmentGridList;



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/DevelopmentGridList.tsx